<template>
  <b-modal
    :id="id"
    :title="trans('send_oto_amilia')"
    :ok-title="trans('cancel')"
    ok-variant="secondary"
    ok-only
    size="xl"
    @show="onShow"
    :ok-disabled="busy"
  >
    <p class="lead text-center my-4" v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
    </p>

    <amilia-import-live-list
      v-if="value"
      :rows="5"
      :organization="organization"
      :recipient_list="value"
      ignore-dirty-check
      @save="onSave"
    >
    </amilia-import-live-list>

  </b-modal>
</template>

<script>
  import AmiliaImportLiveList from './../list/AmiliaImportLiveListComponent'

  export default {
    props: {
      organization: Object,
      value: Object,
      id: {
        type: String,
        default: 'send-oto-amilia',
      },
    },
    components: {
      AmiliaImportLiveList,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        busy: false,
        error: null,
        message: null,
      }
    },
    methods: {
      onShow() {
        if (this.value || this.busy) return
        // Create the list
        let url = `/organization/${this.organization.id}/sendout/oto_list`
        this.busy = true
        axios.post(url, {
          name: trans('send_oto_amilia'),
          description: trans('send_oto_amilia_about'),
          type: 'amilia_import_program',
        })
        .then(response => {
          this.busy = false
          this.$emit('input', response.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onSave() {
        // Was saved - fetch a fresh list
        let url = `/organization/${this.organization.id}/sendout/oto_list/${this.value.id}`
        this.busy = true
        axios.get(url)
        .then(response => {
          this.busy = false
          this.$bvModal.hide(this.id)
          this.$emit('input', response.data)
          this.$emit('save')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.otoAmiliaListComponent = this
    },
  }
</script>